import { render, staticRenderFns } from "./StockViewReleaseProductStepAddress.vue?vue&type=template&id=598822be"
import script from "./StockViewReleaseProductStepAddress.vue?vue&type=script&lang=js"
export * from "./StockViewReleaseProductStepAddress.vue?vue&type=script&lang=js"
import style0 from "./StockViewReleaseProductStepAddress.vue?vue&type=style&index=0&id=598822be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports